import { render, staticRenderFns } from "./edit-comment-modal.vue?vue&type=template&id=e5186154&"
import script from "./edit-comment-modal.vue?vue&type=script&lang=ts&"
export * from "./edit-comment-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports